import React from 'react';

import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { AdminNavigation } from 'containers/AdminNavigation';
import { AdminPageLayout } from 'design/adminPageLayout';
import { ClientsPageContent } from 'containers/ClientsPageContent';

type MatchParams = {
  page: string;
};

export const ClientsPage = () => {
  const {
    params: { page: currentPageText },
  } = useRouteMatchStrict<MatchParams>();

  // Номер страницы из роутера приходит в виде текста.
  // Для дальнейшей работы значение приводится к числу.
  const currentPage = Number(currentPageText);

  return (
    <AdminPageLayout
      sidebarNode={<AdminNavigation />}
      contentNode={<ClientsPageContent currentPage={currentPage} />}
    />
  );
};
